(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("locale/locale_he", [], factory);
	else if(typeof exports === 'object')
		exports["locale/locale_he"] = factory();
	else
		root["locale/locale_he"] = factory();
})(window, function() {
return 